module.exports = __webpack_public_path__ + "img/flag-burgundy.990442f6.svg";